/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_options.js                                                                       */
/**********************************************************************************************************************/
/* Subscriptions Options */
HafasWebapp.prototype.subscriptions.options = function (_me) {

  /*** GETTER *********************************************************************************************************/

  Hafas.ps.sub('/options/get/model/id', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) return Hafas.bind(_me.Controller.Options.getModelById, _me)(params);
  });

  Hafas.ps.sub('/options/get/model/name', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) return Hafas.bind(_me.Controller.Options.getModelByName, _me)(params);
  });

  Hafas.ps.sub('/options/get/change', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) return Hafas.bind(_me.Controller.Options.haveOptionsChanged, _me)(params);
  });

  Hafas.ps.sub('/options/get/change/text', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) return Hafas.bind(_me.Controller.Options.getOptionTexts, _me)(params);
  });

  /*** SETTER *********************************************************************************************************/

  Hafas.ps.sub('/options/set/value', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.setOptionValue, _me)(params);
  });

  Hafas.ps.sub('/options/set/parameter', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.setOptionParameter, _me)(params);
  });

  Hafas.ps.sub('/options/set/products', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.setProducts, _me)(params);
  });

  Hafas.ps.sub('/options/reset/products', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.resetProducts, _me)(params);
  });

  // Auswahl alle Verkehrsmittel
  Hafas.ps.sub('/options/set/products/all', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.setAllProducts, _me)(params);
  });
  // Auswahl Regionalverkehr
  Hafas.ps.sub('/options/set/products/regio', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.setRegioProducts, _me)(params);
  });

  Hafas.ps.sub('/options/reset', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.resetOptions, _me)(params);
  });

  Hafas.ps.sub('/options/init', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.initOptions, _me)(params);
  });

  /*** GUI ************************************************************************************************************/

  Hafas.ps.sub('/options/gui/render', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.renderOptions, _me)(params);
  });

  Hafas.ps.sub('/options/gui/toggle', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.toggleOptionDialog, _me)(params);
  });

  Hafas.ps.sub('/options/gui/toggle/group', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.toggleOptionGroup, _me)(params);
  });

  Hafas.ps.sub('/options/gui/toggle/via/options', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.toggleViaOptions, _me)(params);
  });

  Hafas.ps.sub('/options/gui/toggle/delete', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.toggleDeleteButton, _me)(params);
  });

  Hafas.ps.sub('/options/gui/close/groups', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.closeAllOptionGroups, _me)(params);
  });

  Hafas.ps.sub('/options/setChangedOptionsInputForm', function(params) {
    if(Hafas.Config[_me.appContext].useQueryOptions) Hafas.bind(_me.Controller.Options.GUI.setChangedOptionsInputForm, _me)(params);
  });

};
